// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.id-card-back {
  box-sizing: border-box;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  width: 55mm;
  height: 85mm;
  background-color: #fff;
  margin: 40px 20px;
  overflow: hidden;
  padding: 0 0 0 7.2mm;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  flex-direction: column;
}

.id-card-back:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.id-card-back__top {
  width: 100%;
  height: auto;
  margin-top: 15mm;
}

.id-card-back__main {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.id-card-back__bottom {
  width: 100%;
  height: auto;
  margin-top: 4mm;
}

.id-card-back__main p.address {
  margin-bottom: 3mm;
}

.id-card-back__top p,
.id-card-back__bottom p {
  margin-bottom: 3mm;
}

.id-card-back__top p,
.id-card-back__main p,
.id-card-back__bottom p {
  font-size: 7pt;
  font-family: 'Inter';
  font-weight: 360;
}

.id-card-back__top p.bold,
.id-card-back__main p.bold,
.id-card-back__bottom p.bold {
  font-weight: 630;
}
`, "",{"version":3,"sources":["webpack://./src/components/idCardBack/IdCardBack.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wEAAwE;EACxE,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB","sourcesContent":[".id-card-back {\n  box-sizing: border-box;\n  text-align: left;\n  display: flex;\n  flex-wrap: wrap;\n  width: 55mm;\n  height: 85mm;\n  background-color: #fff;\n  margin: 40px 20px;\n  overflow: hidden;\n  padding: 0 0 0 7.2mm;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  flex-direction: column;\n}\n\n.id-card-back:hover {\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n}\n\n.id-card-back__top {\n  width: 100%;\n  height: auto;\n  margin-top: 15mm;\n}\n\n.id-card-back__main {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n}\n\n.id-card-back__bottom {\n  width: 100%;\n  height: auto;\n  margin-top: 4mm;\n}\n\n.id-card-back__main p.address {\n  margin-bottom: 3mm;\n}\n\n.id-card-back__top p,\n.id-card-back__bottom p {\n  margin-bottom: 3mm;\n}\n\n.id-card-back__top p,\n.id-card-back__main p,\n.id-card-back__bottom p {\n  font-size: 7pt;\n  font-family: 'Inter';\n  font-weight: 360;\n}\n\n.id-card-back__top p.bold,\n.id-card-back__main p.bold,\n.id-card-back__bottom p.bold {\n  font-weight: 630;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
